module.exports = __webpack_public_path__ + "img/default-logo.7ea8b502.png";